import i18next from 'i18next';

i18next.addResources('es', 'navbar', {
  title: 'Base de datos de proyectos de infraestructura',
  home: 'Inicio',
  digitalContent: 'Contenidos',
  projects: 'Índice de Proyectos',
  schedule: 'Agenda',
  whatWeDo: 'Alianza',
  events: 'Eventos',
  sendera: 'ILAT',
  projectCharts: 'Gráficos de proyectos',
  maps: 'Mapa',
  routes: 'Proyectos por País',
  charts: 'Analíticas',
  logout: 'Cerrar sesión'
});

i18next.addResources('en', 'navbar', {
  title: 'Infrastructure Projects Database',
  home: 'Home',
  digitalContent: 'Content',
  projects: 'Project Index',
  schedule: 'Schedule',
  whatWeDo: 'Alliance',
  events: 'Events',
  sendera: 'ILAT',
  projectCharts: 'Project Charts',
  maps: 'Map',
  routes: 'Projects by Country',
  charts: 'Analytics',
  logout: 'Log out'
});

i18next.addResources('pt', 'navbar', {
  title: 'Base de dados de projetos de infraestrutura',
  home: 'Início',
  digitalContent: 'Conteúdo',
  projects: 'Índice de Projetos',
  schedule: 'Agenda',
  whatWeDo: 'Aliança',
  events: 'Eventos',
  sendera: 'ILAT',
  projectCharts: 'Gráficos de projetos',
  maps: 'Mapa',
  routes: 'Projetos por Pais',
  charts: 'Análise',
  logout: 'Sair'
});
